import React, { useContext } from "react";
import AppliedProduct from "./applied";
import OpenProduct from "./open";
import { DashboardProps } from "../index";
import { Product } from "../../../context/product-context/product";
import { DashboardBasicAccountApplicationDocument } from "../../../api/commercial/generated-types";
import { ProductContext } from "../../../context/product-context/productContext";
import { ProductRefType } from "../../../context/product-context/types";

interface DashboardBAAProps {
  basicAccountApplications: DashboardBasicAccountApplicationDocument[];
  openProducts: Product[];
  openProductSelector: () => void;
  openCsDisabledDialog: () => void;
  startBasicAccountApplication: DashboardProps["startBasicAccountApplication"];
  startCardApplication: DashboardProps["startCardApplication"];
}

const DashboardBasicAccountApplication = ({
  basicAccountApplications,
  openProducts,
  openProductSelector,
  openCsDisabledDialog,
  startBasicAccountApplication,
  startCardApplication,
}: DashboardBAAProps): React.JSX.Element => {
  const { findPersistedProductByRef } = useContext(ProductContext);

  const renderAppliedProducts = () => {
    return basicAccountApplications.map((appliedApplication) => (
      <AppliedProduct
        key={appliedApplication.applicationRef}
        startCardApplication={startCardApplication}
        startBasicAccountApplication={startBasicAccountApplication}
        openProductSelector={openProductSelector}
        openCsDisabledDialog={openCsDisabledDialog}
        appliedApplication={appliedApplication}
        isDisabled={
          !findPersistedProductByRef(
            appliedApplication.productRef as ProductRefType,
          )?.isActive
        }
      />
    ));
  };

  return (
    <>
      {renderAppliedProducts()}
      {openProducts.map((product) => (
        <OpenProduct
          key={product.productRef}
          product={product.productRef}
          startApplication={startBasicAccountApplication}
        />
      ))}
    </>
  );
};

export default DashboardBasicAccountApplication;
